export var DA_EMOTE_TYPE = 'da-draft-plugin-emote';
export var DA_COMM_EMOTE = 'DA_COMM_EMOTE';
export var DA_OFF_EMOTE = 'DA_OFF_EMOTE';
//# sourceMappingURL=types.js.map